export const SIGN_OUT_ROUTE = '/auth/sign-out';
export const SIGN_IN_ROUTE = '/auth/sign-in';

export const CONFIRM_REQUIRED_ROUTE = '/confirmation-required';

export const SIGN_IN_REDIRECT_URL = '/signed-in-redirect';
